import { render, staticRenderFns } from "./Autobiography.vue?vue&type=template&id=2d45cc58&scoped=true"
import script from "./Autobiography.vue?vue&type=script&lang=js"
export * from "./Autobiography.vue?vue&type=script&lang=js"
import style0 from "./Autobiography.vue?vue&type=style&index=0&id=2d45cc58&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d45cc58",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\BuildAgent\\work\\136\\s\\Yahome.RecruitSystem.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2d45cc58')) {
      api.createRecord('2d45cc58', component.options)
    } else {
      api.reload('2d45cc58', component.options)
    }
    module.hot.accept("./Autobiography.vue?vue&type=template&id=2d45cc58&scoped=true", function () {
      api.rerender('2d45cc58', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customize/Front/IDL/Autobiography.vue"
export default component.exports